﻿<template>
    <div v-if="hasTripDate" class="pick-up mt-8 flex border border-aat-greylight rounded-sm" :class="{ hidden: !display_pickup_points() }">

        <div class="text-heading flex-0 pt-2 pb-3 px-8">
            <strong class="text-black">Select your hotel pick-up:</strong>
            <div class="text-xs text-aat-grey mt-1">(with approx time)</div>
        </div>

        <div id="Pickup_Point_Click_Away" class="flex-1 vc-title" v-click-away="onClickAway">
            <button type="button" class="select-button" @click="isOpen = !isOpen" :class="{'active': isOpen}">
                <strong>{{getPickupDisplayName(selected_pickup_point)}}</strong>
            </button>
            <div class="select-dropdown w-80" v-if="isOpen">
                <ul>
                    <li v-for="pickup_point in pickup_points?.points"
                        class="text-sm"
                        :class="[ pickup_point.point_id === selected_pickup_point.point_id ? 'selected' : '' ]"
                        @click="Pickup_Click(pickup_point)">
                        {{getPickupDisplayName(pickup_point)}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div v-else :class="{ hidden: !display_pickup_points() }">
        <div class="flex items-center justify-center text-bold px-8 pt-4 pb-2 text-aat-red text-sm w-full text-center">
            Please select a date to choose hotel pick-up.
        </div>
        <div class="pick-up flex border border-aat-greylight rounded-sm opacity-50 pointer-events-none bg-aat-greylight" :class="{ hidden: !display_pickup_points() }">
        
            <div class="text-heading flex-0 pt-2 pb-3 px-8">
                <strong class="text-black">Select your hotel pick-up:</strong>
                <div class="text-xs text-aat-grey mt-1">(with approx time)</div>
            </div>

            <div id="Pickup_Point_Click_Away" class="flex-1 vc-title" v-click-away="onClickAway">
                
                <button type="button" class="select-button" @click="(isOpen = !isOpen)" :class="{ 'active': isOpen }" title="Please select a trip date first">
                    <strong>{{getPickupDisplayName(selected_pickup_point)}}</strong>
                </button>
                
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./pickup.ts"></script>